// Shown by every route guard when the session or device check fails for any
// reason other than a 401 — the server is unreachable, or the edge WAF refused
// the caller's network. One constant so the wording stays identical across the
// client, kiosk and admin surfaces, which each present it differently.
export const SERVER_UNREACHABLE_MESSAGE = "We can't reach the server right now."
